import { useTranslation } from 'react-i18next'

export function useGlAccountLabel() {
  const { t, i18n } = useTranslation('accounting')
  return (code: string | null | undefined, system: boolean | undefined, label: string): string => {
    const key = `accounts.${code}`
    return system === true && code && i18n.exists(`accounting:${key}`) ? t(key) : label
  }
}
